/**
 * Easter egg hunt, header side. The navbar renders on every page, so this is
 * the one place guaranteed to run everywhere:
 *
 * - the permanent golden glow on the logo for anyone who found every egg
 * - the console hint that the hunt exists at all
 * - the console handle, so the hunt can be inspected and reset by hand
 */

import { applyCompletionGlow } from '../../../../assets/frontend/js/easterEggs/effects/completion'
import { progress, reset } from '../../../../assets/frontend/js/easterEggs/engine'
import { printEasterEggHint } from '../../../../assets/frontend/js/easterEggs/hint'

// window.icfEasterEggs.reset() / .progress() from the browser console. Handing
// out the reset is harmless: it only ever clears the visitor's own progress.
window.icfEasterEggs = { progress, reset }

if (progress().complete) {
  applyCompletionGlow()
}

printEasterEggHint()
